import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';

import { sumObjectsByKey } from './utils/functions';
import icons from './utils/icons';
const { clock, menu, close } = icons;

const SteppedContent = ({ attributes, content, clientId, isBackend = false, custom = {} }) => {
	const { data, title, isDoneBtn, doneBtnLink } = attributes;

	const [step, setStep] = useState(1);
	const [mobileMenuActive, setMobileMenuActive] = useState('');

	const rt = sumObjectsByKey(...data.map(d => d.duration));
	const rtMS = { m: (rt.h * 60) + rt.m + Math.floor(rt.s / 60), s: rt.s % 60 };

	const minuteText = 1 === rtMS.m ? __('1 minute', 'stepped-content') : `${rtMS.m} ${__('minutes', 'stepped-content')}`;
	const secondText = 1 === rtMS.s ? __('1 second', 'stepped-content') : `${rtMS.s} ${__('seconds', 'stepped-content')}`;
	const remainingText = `${minuteText} and ${secondText}`;

	const allStepSelector = isBackend ? `#stpContent-${clientId} .stpSteps > .block-editor-inner-blocks > .block-editor-block-list__layout > div[data-type='stp/step']` : `#stpContent-${clientId} .stpSteps > div.stpStep`;
	const allStepEls = document.querySelectorAll(allStepSelector);

	const onSetStep = (changedStep) => {
		setStep(changedStep);

		allStepEls.forEach((stepEl, index) => {
			const elStep = index + 1;

			stepEl.setAttribute('data-selected', elStep === changedStep);

			stepEl.style.transform = elStep < changedStep
				? 'translate3d(-110%, 0px, 0px)'
				: elStep > changedStep
					? 'translate3d(110%, 0px, 0px)'
					: 'translate3d(0px, 0px, 0px)';

			setTimeout(() => {
				stepEl.display = elStep === changedStep ? 'block' : 'none';
			}, 300);
		});
	};

	useEffect(() => {
		onSetStep(step);
	}, [allStepEls, data?.length]);

	isBackend && useEffect(() => {
		switch (custom.stepUpdateType) {
			case 'add':
				onSetStep(data.length)
				break;
			case 'delete':
				onSetStep(step - 1)
				break;
			default:
				onSetStep(step);
				break;
		}
		custom.setStepUpdateType('')
	}, [custom.stepUpdateType]);

	return <div className='stpContent'>
		<nav className='stpNav'>
			{mobileMenuActive ? <a className='menuClose' title='Close Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('');
			}}>{close}</a> : <a className='menuOpen' title='Open Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('active');
			}}>{menu}</a>}

			<h2>{title}</h2>

			<div className='remainingTime'>
				{clock}
				{remainingText}
			</div>
		</nav>

		<div className='stpSection' onClick={() => setMobileMenuActive('')}>
			<nav className={`stpMenu ${mobileMenuActive}`}>
				<ol>
					{data.length ? data.map((d) => <li key={d.step} data-completed={d.step <= step} data-selected={d.step === step} onClick={() => onSetStep(d.step)}>
						<a>
							<span>{d.title}</span>
						</a>
					</li>) : <li><a>Please add a step!</a></li>}
				</ol>
			</nav>

			<div className='stpStepsWrapper'>
				{isBackend
					? <div className='stpSteps'>{content}</div>
					: <div className='stpSteps' dangerouslySetInnerHTML={{ __html: content.replace(/\s+/g, ' ') }} />}

				<div className='sptStepsControls'>
					<div className='controlsInner'>
						{1 < step && <button className='docControlBtn prevBtn' title='Previous step' onClick={() => onSetStep(step - 1)}>{__('Back', 'stepped-content')}</button>}

						{step === data.length && isDoneBtn && <a link={doneBtnLink} className='docControlBtn doneBtn' title='Document Complete'>{__('Done', 'stepped-content')}</a>}

						{step < data.length && <button className='docControlBtn nextBtn' title='Next step' onClick={() => onSetStep(step + 1)}>{__('Next', 'stepped-content')}</button>}
					</div>
				</div>
			</div> {/* Steps Wrapper */}
		</div>
	</div>
}
export default SteppedContent;